import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import DataTable from '../../DataTable';
import Spinner from '../../Spinner';
import { getDisplayDate } from '../../../libs/date';
import parameterTypeParser from "../../../libs/parameterTypeParser";
import _ from 'lodash';

@inject('stationStore', 'qcFlagStore')
@observer
class StationMonitoringList extends Component {
  @observable lastCommunicationTime;
  @observable isLoading = false;

  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
  };

  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    const { params: { id }, qcFlagStore } = this.props;
    if (!qcFlagStore.items.length && !qcFlagStore.isLoading) qcFlagStore.fetchItems();
    this.fetchData(id);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetchData(nextProps.params.id);
    }
  }

  fetchData(id) {
    const { stationStore } = this.props;
    this.isLoading = true;
    Promise.all([stationStore.fetchMonitorings(id), stationStore.fetchDataSeries(id)])
      .then(res => {
        let data = res[0];
        this.lastCommunicationTime = data.last_communication_time && getDisplayDate(data.last_communication_time);
        // .format('YYYY-MM-DD HH:mm:ss');
      })
      .catch(err => {
        console.log('err', err);
      }).finally(() => {
        this.isLoading = false;
      });
  }


  handleDelete(dataOriginId) {
    const { params: { id } } = this.props;
    this.props.stationStore.removeMonitoring(id, dataOriginId);
  }

  render() {
    const { params: { id }, stationStore, children, qcFlagStore } = this.props;
    const parentSlug = `/station/${id}/data-origin`;
    const columns = [
      { key: 'data_series', label: 'Data Series' },
      { key: 'sample_time', label: 'Sample Time' },
      { key: 'value', label: 'Value' },
      { key: 'symbol', label: 'Symbol' },
      { key: 'date_and_time', label: 'Date and Time' },
      { key: 'qc', label: 'QC' },
      { key: 'count', label: 'Count (Last 7 Days)' },
    ];

    const station = stationStore.findById(id);
    // console.log('station.monitoring', station);

    if ((this.isLoading && !children) || qcFlagStore.isLoading) { return <Spinner />; }

    const stationMonitoring = station.monitoring
      .map((item) => {
        return Object.assign({}, item, {
          sample_time: item.sample_time && getDisplayDate(item.sample_time),
          // date_and_time: item.date_and_time && getDisplayDate(item.date_and_time),
          date_and_time: item.qc_check && item.qc_check.time && getDisplayDate(item.qc_check.time),
          qc: item.qc_check && qcFlagStore.getDescription(item.qc_check.max_qc_flag),
          count: item.qc_check && item.qc_check.max_qc_flag_count,
          value: parameterTypeParser(item.value, _.get(station.data_series.find(parameter => +parameter.id === +item.id), 'property'))
        });
        // return Object.assign({}, item, {
        //   sample_time: item.sample_time && moment(item.sample_time).format('YYYY-MM-DD kk-mm-ss'),
        //   date_and_time: item.date_and_time && moment(item.date_and_time).format('YYYY-MM-DD kk-mm-ss'),
        // });
      });
    return (
      <div>
        <div>
          <h3>Real Time Station Status</h3>
          <p>Last Communication Time: {this.lastCommunicationTime}</p>
        </div>
        <DataTable
          data={stationMonitoring}
          slug={'monitoring'}
          columns={columns}
          onDelete={this.handleDelete}
        />
      </div>
    );
  }
}

export default StationMonitoringList;



// WEBPACK FOOTER //
// ./src/components/Station/Monitoring/StationMonitoringList.js